import { STATUS_LABELS } from "@lib/types";
import { StateBadge, type StateBadgeTone } from "./StateBadge";

const CAMPAIGN_STATUS_TONE: Record<string, StateBadgeTone> = {
  draft: "muted",
  active: "info",
  on_hold: "warning",
  completed: "success",
  cancelled: "error",
};

interface Props {
  status: string;
  label?: string;
}

export function StatusPill({ status, label }: Props) {
  const tone = CAMPAIGN_STATUS_TONE[status] ?? "neutral";
  return <StateBadge tone={tone} label={label ?? STATUS_LABELS[status] ?? status} />;
}
